import React from "react"
import styled from "styled-components"

const Holder = styled.div`
  max-width: ${(props) => props.theme.typography.maxScreen}px;
  margin: 0 auto;
  padding: 0 2rem;
`;

function Container({ className, children }) {
  return (
      <Holder className={className}>
        {children}
      </Holder>
  )
}

export default Container
